var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": "page",
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
        },
        scopedSlots: _vm._u([
          {
            key: "search-account",
            fn: function ({ query }) {
              return [
                _c("el-input", {
                  attrs: {
                    placeholder:
                      query.accountType === "uid"
                        ? "输入代理ID"
                        : "输入代理账号",
                    inputmode: query.accountType === "uid" ? "numeric" : "text",
                    maxlength: "20",
                    clearable: "",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.onAccountInput(query, $event)
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "prepend",
                        fn: function () {
                          return [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100px" },
                                on: {
                                  change: function ($event) {
                                    return _vm.onAccountTypeChange(
                                      query,
                                      $event
                                    )
                                  },
                                },
                                model: {
                                  value: query.accountType,
                                  callback: function ($$v) {
                                    _vm.$set(query, "accountType", $$v)
                                  },
                                  expression: "query.accountType",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "代理账号",
                                    value: "username",
                                  },
                                }),
                                _c("el-option", {
                                  attrs: { label: "代理ID", value: "uid" },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: query.accountValue,
                    callback: function ($$v) {
                      _vm.$set(query, "accountValue", $$v)
                    },
                    expression: "query.accountValue",
                  },
                }),
              ]
            },
          },
          {
            key: "table-header",
            fn: function () {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v("新增代理")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.handleAgentModeSetting },
                      },
                      [_vm._v("普通代理设置")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.handleOfficialAgentModeSetting },
                      },
                      [_vm._v("官方代理设置")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "colUsername",
            fn: function ({ row }) {
              return [
                _c("MemberAccountCell", {
                  key: row.uid,
                  attrs: {
                    row: row,
                    "vip-level": row.agent_level,
                    username: row.username,
                    uid: row.uid,
                    "tag-prefix": "LV",
                    "tag-type": row.agent_status === 2 ? "warning" : "info",
                  },
                }),
              ]
            },
          },
          {
            key: "colAgentStatus",
            fn: function ({ row }) {
              return [
                _vm._v(
                  " " +
                    _vm._s(_vm._f("formatAgentStatus")(row.agent_status)) +
                    " "
                ),
              ]
            },
          },
          {
            key: "colInviterUsername",
            fn: function ({ row }) {
              return [
                !row.inviter_uid
                  ? _c("span", [_vm._v("--")])
                  : _c("MemberAccountCell", {
                      key: row.inviter_uid,
                      attrs: {
                        row: {
                          uid: row.inviter_uid,
                          username: row.inviter_username,
                        },
                        username: row.inviter_username,
                        uid: row.inviter_uid,
                      },
                    }),
              ]
            },
          },
          {
            key: "colShareNum",
            fn: function ({ row }) {
              return [
                !row.share_num
                  ? _c("span", [_vm._v("--")])
                  : _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleViewAgents(row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(row.share_num))]
                    ),
              ]
            },
          },
          {
            key: "colShareTwoNum",
            fn: function ({ row }) {
              return [
                !row.share_two_num
                  ? _c("span", [_vm._v("--")])
                  : _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleViewIndirectAgents(row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(row.share_two_num))]
                    ),
              ]
            },
          },
          {
            key: "colBackGold",
            fn: function ({ row }) {
              return [
                _vm._v(
                  " " + _vm._s(_vm._f("centsToYuan")(row.agent_back_gold)) + " "
                ),
              ]
            },
          },
          {
            key: "colActions",
            fn: function ({ row }) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handlePreview(row)
                      },
                    },
                  },
                  [_vm._v("查看")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleEdit(row)
                      },
                    },
                  },
                  [_vm._v("编辑")]
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          staticClass: "page-dialog center-dialog",
          attrs: {
            visible: _vm.addDialogVisible,
            title: _vm.isEdit
              ? "编辑代理"
              : _vm.isPreview
              ? "查看代理"
              : "新增代理",
            width: "600px",
          },
          on: {
            close: function ($event) {
              _vm.addDialogVisible = false
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addFormRef",
              staticClass: "add-level-form",
              attrs: {
                model: _vm.addAgentForm,
                rules: _vm.addFormRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "代理账号", prop: "username" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isPreview || _vm.isEdit,
                      type: "textarea",
                      rows: _vm.isPreview || _vm.isEdit ? 1 : 6,
                      placeholder: "请输入代理账号，每行一个",
                    },
                    model: {
                      value: _vm.addAgentForm.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.addAgentForm, "username", $$v)
                      },
                      expression: "addAgentForm.username",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "代理类型", prop: "agent_status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.isPreview },
                      model: {
                        value: _vm.addAgentForm.agent_status,
                        callback: function ($$v) {
                          _vm.$set(_vm.addAgentForm, "agent_status", $$v)
                        },
                        expression: "addAgentForm.agent_status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1, value: 1 } }, [
                        _vm._v("普通代理"),
                      ]),
                      _c("el-radio", { attrs: { label: 2, value: 2 } }, [
                        _vm._v("官方代理"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.addAgentForm.agent_status === 1 ||
              _vm.addAgentForm.agent_status === 2
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        margin: "0px 0 22px 100px",
                        width: "400px",
                        "background-color": "#f4f4f5",
                        color: "#909399",
                        padding: "10px",
                        "border-radius": "5px",
                      },
                    },
                    [
                      _vm.addAgentForm.agent_status === 1
                        ? _c(
                            "ul",
                            {
                              staticStyle: {
                                "list-style": "none",
                                padding: "0",
                                margin: "0",
                              },
                            },
                            [
                              _c("li", [
                                _vm._v(
                                  "代理计算层级：" +
                                    _vm._s(
                                      _vm._f("formatLevelCount")(
                                        _vm.agentModeSetting?.level_count
                                      )
                                    )
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  "直接下级返佣比例：" +
                                    _vm._s(
                                      _vm.agentModeSetting?.share_one_rate
                                    ) +
                                    "%"
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  "二级代理返佣比例：" +
                                    _vm._s(
                                      _vm.agentModeSetting?.share_two_rate
                                    ) +
                                    "%"
                                ),
                              ]),
                            ]
                          )
                        : _c(
                            "ul",
                            {
                              staticStyle: {
                                "list-style": "none",
                                padding: "0",
                                margin: "0",
                              },
                            },
                            [
                              _c("li", [
                                _vm._v(
                                  "代理名称：" +
                                    _vm._s(_vm.currentAgentLevel?.level_name)
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  "新增直属下级(人数)：" +
                                    _vm._s(
                                      _vm._f("formatShareNum")(
                                        _vm.currentAgentLevel?.need_share_num
                                      )
                                    )
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  "晋级条件(需再获得佣金)：≥" +
                                    _vm._s(
                                      _vm._f("formatGold")(
                                        _vm.currentAgentLevel?.upgrade_need_gold
                                      )
                                    )
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  "直属代理佣金比例：" +
                                    _vm._s(
                                      _vm.currentAgentLevel?.share_one_rate
                                    ) +
                                    "%"
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  "二级代理佣金比例：" +
                                    _vm._s(
                                      _vm.currentAgentLevel?.share_two_rate
                                    ) +
                                    "%"
                                ),
                              ]),
                            ]
                          ),
                    ]
                  )
                : _vm._e(),
              _vm.addAgentForm.agent_status === 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "代理等级", prop: "agent_level" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择",
                            disabled: _vm.isPreview,
                          },
                          model: {
                            value: _vm.addAgentForm.agent_level,
                            callback: function ($$v) {
                              _vm.$set(_vm.addAgentForm, "agent_level", $$v)
                            },
                            expression: "addAgentForm.agent_level",
                          },
                        },
                        _vm._l(_vm.agentLevelList, function (item) {
                          return _c("el-option", {
                            key: item.agent_level,
                            attrs: {
                              label: `LV${item.agent_level}`,
                              value: item.agent_level,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isPreview && !_vm.isEdit
                ? _c(
                    "el-form-item",
                    { attrs: { label: "代理密码", prop: "password" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.addAgentForm.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.addAgentForm, "password", $$v)
                          },
                          expression: "addAgentForm.password",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "代理备注", prop: "agent_remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isPreview,
                      type: "textarea",
                      rows: 6,
                    },
                    model: {
                      value: _vm.addAgentForm.agent_remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.addAgentForm, "agent_remark", $$v)
                      },
                      expression: "addAgentForm.agent_remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleAddSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("AgentCountListDialog", {
        attrs: {
          visible: _vm.agentCountListDialogVisible,
          level: _vm.agent_level,
        },
        on: {
          "update:visible": function ($event) {
            _vm.agentCountListDialogVisible = $event
          },
          closed: _vm.handleAgentCountListClosed,
        },
      }),
      _c("AgentModeSettingDialog", {
        attrs: { visible: _vm.agentModeSettingDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.agentModeSettingDialogVisible = $event
          },
          closed: _vm.handleAgentModeSettingClosed,
        },
      }),
      _c("AgentInviteUserListDialog", {
        attrs: {
          visible: _vm.agentInviteUserListDialogVisible,
          "inviter-uid": _vm.agent_uid,
          username: _vm.agent_username,
          type: _vm.agent_type,
        },
        on: {
          "update:visible": function ($event) {
            _vm.agentInviteUserListDialogVisible = $event
          },
          closed: _vm.handleAgentInviteUserListClosed,
        },
      }),
      _c(
        "el-dialog",
        {
          staticClass: "page-dialog center-dialog official-agent-level-dialog",
          attrs: {
            title: "官方代理设置",
            visible: _vm.officialAgentLevelDialogVisible,
            width: "1200px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.officialAgentLevelDialogVisible = $event
            },
          },
        },
        [
          _vm.officialAgentLevelDialogVisible
            ? _c("AgentLevel", { attrs: { "dialog-mode": true } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }